import { render, staticRenderFns } from "./Game3-9.vue?vue&type=template&id=50ff953e&scoped=true&"
import script from "./Game3-9.vue?vue&type=script&lang=js&"
export * from "./Game3-9.vue?vue&type=script&lang=js&"
import style0 from "./Game3-9.vue?vue&type=style&index=0&id=50ff953e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff953e",
  null
  
)

export default component.exports